import React, { useEffect, useState } from "react";

const QUOTES = [
  { text: "Still the best Chicken Fingers", author: "-Jules Winbert" },
  { text: "Very Tasty Pizza Fingers", author: "-John Lockton" },
  { text: "The best Subs in Lockport... by a mile", author: "-Union-Sun & Journal" },
];

export default function HeroQuotes() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % QUOTES.length), 4500);
    return () => clearInterval(t);
  }, []);

  const q = QUOTES[idx];

  return (
    <section className="sd-hero-quote py-8" data-testid="hero-quotes">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-6 items-center">
          <div className="min-h-[90px] flex flex-col justify-center" data-testid="hero-quote-slide">
            <h2 className="sd-quote-text" data-testid="hero-quote-text">
              {q.text}
            </h2>
            <p className="mt-2 text-white/90 font-display tracking-wide">{q.author}</p>
            <div className="sd-dots mt-3 justify-start" data-testid="hero-quote-dots">
              {QUOTES.map((_, i) => (
                <span
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`sd-dot ${i === idx ? "active" : ""}`}
                  data-testid={`hero-dot-${i}`}
                />
              ))}
            </div>
          </div>
          <div className="hidden md:block" />
        </div>
      </div>
    </section>
  );
}
